<template>
    <div v-if="isShowGoHome" class="toHome" @click="toHome"></div>
</template>
<script>
export default {
    name: 'GoHome',
    data() {
        return {
            isShowGoHome: true,
        }
    },
    created() {
        this.isShowGoHome = this.$route.query.isMP == 1 ? false : true;
    },
    methods: {
        toHome() {
            this.$router.push('/')
        },
    }
}
</script>
<style lang="less" scoped>
.toHome {
    width: 17.867vw;
    height: 17.867vw;
    background: url('./../assets/img/toHome.png') center no-repeat;
    background-size: cover;
    position: fixed;
    bottom: 30.667vw;
    right: 2.133vw;
}
</style>